import {useContext, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";

export function useRedirectAuthenticatedEffect(target = '/') {
    const navigate = useNavigate();
    const {context} = useContext(GlobalContext);

    useEffect(() => {
        redirectAuthenticatedIdentity({currentIdentity: context.currentIdentity, navigate, target});
    }, [context.currentIdentity, navigate, target]);
}

export function redirectAuthenticatedIdentity({currentIdentity, navigate, target = '/'}) {
    if (currentIdentity !== null) navigate(target);
}
